<template>
	<div class="animated fadeIn">
        <loading :active.sync="isLoading"></loading>
		<br>
		<b-row>
			<b-col class="highlighted" lg="6" md="6" sm="6">
				<label for="clients">{{ $t('menu.select_client') }}
				</label>
				<b-form-select id="clients" v-model="selectedClient" @change="selectChanged()"
					:plain="true"
					:options="clientsOptions">
				</b-form-select>
			</b-col>
		</b-row>	
		
		<b-row>
			<b-col v-if="clients.length > 0" v-for="client in clients" cols="12" sm="12" lg="12" class="change-display">
				<div class="table-responsive-md">
					<div class="client-info">Client: {{client.first_name}} {{client.last_name}} </div>	
					<table class="table">
						<thead>
							<th>
								Week
							</th>
							<th>
								Date Time
							</th>
							<th>
								Menus
							</th>
							<th>
								Action
							</th>
						</thead>
						<tbody>
							<tr v-if="weeks.length > 0" v-for="(week,id) in client.weeks">
								<td>{{getWeek(id).title}}</td>
								<td>{{getWeek(id).start}} - {{getWeek(id).end}}</td>
								<td>{{week.length}}</td>
								<td> 
									<router-link class="btn btn-primary" :to="'/nutritionist/weeks/menus/'+id+'/'+client.id">View</router-link> 
									<button @click="shareClientWeekly(id,client.id)" class="btn btn-success ml-2">Share with client</button>
									<!-- <router-link :to="'/nutritionist/weeks/menus/'+id+'/'+client.id">Share with client</router-link> -->
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</b-col>
			<br>
			<b-col v-if="clients.length == 0" style="margin:20px;" cols="12" sm="12" lg="12" class="change-display">
				<h3>No Data</h3>
			</b-col>
			<br>
			<b-col v-if="clients.length > 0" cols="12" lg="12">
				<b-pagination v-if="!!showPagination" v-model="currentPage" :total-rows="rows" :per-page="perPage" aria-controls="itemList" align="center"></b-pagination>
			</b-col>
		</b-row>
    </div>
</template>

<script>

	import moment from 'moment';
	import Models from '@/store/ORM/models.js';
	import WeekService from '@/services/week.service.js';

	export default {
		data: function () {
			return {
				myModal: false,
				weeks: [],
				currentPage: 1,
				perPage: 5,
				rows: 1,
				searchText: '',
				editModal: false,
				week: {},
				showPagination:true,
				clients: [],
				selectedClient:null,
				isLoading:false,
			}
		},
		mounted() {
			this.getWeeks();
			this.getClientWeeklyMenus();
		},
		computed: {

            clientsOptions() {

                let cli = Models.Client.all();
                let options = [{ value: null, text: "None"}]
                for (let i in cli) {
                    let repr = cli[i].id + ' ' + cli[i].first_name + ' ' + cli[i].last_name
                    var d = new Object()
                    d.text = repr
                    d.value = cli[i].id
                    options.push(repr)
                }
                return options
            },
			getUser: function() {
                return this.$store.state['UserModules'].user;
            }
		},
		methods: {
			getWeeks: function() {

				WeekService.getAllWeeks(this.getUser.nutritionist.id)
				.then((response) => {
					this.weeks = response.data.weeks;
			    },err => {
			    	this.weeks = [];
			    });
			},
			getClientWeeklyMenus:function(){
				this.isLoading = true;
				let client_id = null;
				if(!!this.selectedClient){
					client_id = this.selectedClient.split(" ")[0];
				}
				WeekService.getClientWeeklyMenus(this.currentPage,client_id).then((res)=>{
					if(res.data.success){
						this.clients = res.data.data;
						this.rows = res.data.rows;
					}else{
						this.rows = 1;
					}
					this.isLoading = false;
				});
			},
			getWeek(id){
				return this.weeks.find((week) => week.id == id);
			},
			selectChanged(){
				this.getClientWeeklyMenus();
			},
			shareClientWeekly(week_id,client_id) {
				WeekService.shareClientWeekly(week_id,client_id)
				.then((response) => {
					if(response.data.success){
						this.$toastr.success(this.$t('weeks.shared_successfully'), 'Success!');
					}else{
						this.$toastr.error(this.$t('weeks.shared_error'), 'Error!');
					}
				},err => {
						this.$toastr.error(this.$t('weeks.shared_error'), 'Error!');
				});
			},
		},
		watch: {
        	currentPage: function(val, oldVal) {
				this.getClientWeeklyMenus();
			}
		}

	}
</script>

<style>
	.client-info{
		font-size:20px;
	}
	.table-responsive-md{
		width:100%;
	}
</style>